import * as React from 'react';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import { Helmet } from 'react-helmet';
import { themeDefault } from '@fastly/consistently';
import inter from 'inter-ui/Inter (web latin)/Inter.var.woff2';
import 'inter-ui/inter-latin.css';
import { Tokens } from '../styles/tokens';
import { Global } from '../styles/global';
import Header from '@components/Header';
import AllTheScripts from '@components/marketing-scripts/AllTheScripts';

const NormalizeStyles = createGlobalStyle`
/*** The new CSS Reset - version 1.4.2 (last updated 30.11.2021) ***/

/*
    Remove all the styles of the "User-Agent-Stylesheet", except for the 'display' property
    - The "symbol *" part is to solve Firefox SVG sprite bug
 */
*:where(:not(iframe, canvas, img, svg, video):not(svg *, symbol *)) {
    all: unset;
    display: revert;
}

/* Preferred box-sizing value */
*,
*::before,
*::after {
    box-sizing: border-box;
}

/* Remove list styles (bullets/numbers) */
ol, ul, menu {
    list-style: none;
}

/* For images to not be able to exceed their container */
img {
    max-width: 100%;
}

/* removes spacing between cells in tables */
table {
    border-collapse: collapse;
}

/* revert the 'white-space' property for textarea elements on Safari */
textarea {
    white-space: revert;
}

a {
  cursor: pointer;
}

/* revert for bug in Chromium browsers
   - fix for the content editable attribute will work properly. */
:where([contenteditable]){
    -moz-user-modify: read-write;
    -webkit-user-modify: read-write;
    overflow-wrap: break-word;
    -webkit-line-break: after-white-space;
}
`;

interface Props {
  children: React.ReactNode;
}

type Breakpoints = string[] & { sm: string; md: string; lg: string; xl: string; xxl: string };

const breakpoints: Breakpoints = ['544px', '768px', '992px', '1200px', '1600px'] as Breakpoints;
breakpoints.sm = breakpoints[0];
breakpoints.md = breakpoints[1];
breakpoints.lg = breakpoints[2];
breakpoints.xl = breakpoints[3];
breakpoints.xxl = breakpoints[4];

const deptOfKnowTheme = {
  ...themeDefault,
  breakpoints,
};

export default function Layout({ children }: Props): JSX.Element {
  return (
    <>
      <AllTheScripts />
      <ThemeProvider theme={deptOfKnowTheme}>
        <NormalizeStyles />
        <Tokens />
        <Global />
        <Helmet>
          <link as="font" href={inter} rel="preload" crossOrigin="anonymous" />
        </Helmet>
        <Header />
        {children}
      </ThemeProvider>
    </>
  );
}
